import { render, staticRenderFns } from "./DisposalOrdersCreationBlock.vue?vue&type=template&id=4d791b5c"
import script from "./DisposalOrdersCreationBlock.vue?vue&type=script&lang=js"
export * from "./DisposalOrdersCreationBlock.vue?vue&type=script&lang=js"
import style0 from "./DisposalOrdersCreationBlock.vue?vue&type=style&index=0&id=4d791b5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports